import { createNewUser, newObjectId, User } from '@aag-translations/common/lib'
import axios from '../utils/axios'
import getPath from '../utils/Routes'
import { LogLevel, getLogger } from '../utils/logger'
import config from '../config'

const logger = getLogger(config.logLevel)

// Dev-User für lokale Entwicklung ohne SSO
const devUser: User = {
    id: 1,
    userName: 'devuser',
    firstName: 'Local',
    lastName: 'Developer',
    email: 'dev@local.dev',
    active: true,
    individualRights: {
        0: true, // FullAdministrative
        1: true, // User
        2: true, // Projects
        3: true // Languages
    },
    projectRights: {}
}

let currentUser: User = config.sso.ENABLED ? createNewUser() : devUser
logger.debug('Current User: ', currentUser)
logger.debug('SSO enabled: ', config.sso.ENABLED)

export function getIsLoggedIn(): boolean {
    // Wenn SSO deaktiviert ist (Dev-Mode), sind wir immer eingeloggt
    if (!config.sso.ENABLED) {
        return true
    }
    return currentUser.id !== newObjectId
}

export function getCurrentUser(): User {
    return currentUser
}

export async function getUserFromToken(token: string): Promise<User> {
    currentUser = (await axios.get(`${getPath()}?method=getUserFromToken&cookie=${token}`)).data
    logger.debug('Current User from token (backend): ', currentUser)
    return currentUser
}
